module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Black.686001c4.ttf";